export default __webpack_public_path__ + "static/media/IRL.ec5a5647.svg";